import { graphQLFetch } from "../../../utils";
import { GET_REPORT_BY_ID } from "../../queries";

export const getReportById =
  ({ companyId, projectId, fileId }) =>
  async (dispatch, getState) => {
    if (!companyId || !projectId) {
      throw new Error(
        "companyId and projectId are required to fetch BAT report"
      );
    }
    const data = await graphQLFetch(
      GET_REPORT_BY_ID,
      { cId: companyId, pId: projectId, fileId: fileId },
      "query",
      getState
    );

    const signedUrl = data?.getReportById?.url || {};
    return signedUrl;
  };
